import Vue from 'vue'

import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import config from '@/config'

const initState = {
  agencies: [],
  companies: [],
  selectedAgency: null,
  selectedCompany: null,
  sidebarVisible: true,
  currentTabId: 0,
  isLoading: false,
  isDebugMode: 0,
  openGroups: [],
  openSubSections: [],
  showEmptyNotice: false,
  showCustomerPref: false,
  isConceptEdit: false,
  hasConcept: false,
  consultationId: 0
}

function getInitialState (reset = false) {
  const objectKeys = [
    'agencies',
    'companies',
    'selectedAgency',
    'selectedCompany',
  ]

  const excludeKeys = [
    'currentTabId',
    'isLoading',
    'sidebarVisible',
    'openGroups',
    'openSubSections',
    'showEmptyNotice',
    'showCustomerPref',
    'isConceptEdit',
    'hasConcept',
    'consultationId'
  ]

  Object.keys(initState)
    .filter(k => !excludeKeys.includes(k))
    .map(k => {
      initState[k] = config.KEEP_LOGGED_IN && !reset
        ? Vue.localStorage.get(k, null)
        : null

      if (objectKeys.includes(k) && initState[k]) {
        initState[k] = JSON.parse(initState[k])
      }
    })

  return initState
}

mutations.RESET = (state) => {
  const state_ = getInitialState(true)

  Object
    .keys(state_)
    .map(key => {
      state[key] = state_[key]
    })

  Object
    .keys(initState)
    .map(k => Vue.localStorage.remove(k))
}

export default {
  state: getInitialState(),
  mutations,
  getters,
  actions
}
